import { isNil } from 'lodash';

export interface AuthenticationPayloadBase {
  version: number | undefined;
}

export interface AuthenticationPayloadV1 extends AuthenticationPayloadBase {
  apiClientId: string;
  applicationId: string;
  isAdmin: boolean;
  scope: string;
}

export type AuthenticationPayloadResourcesV2 =
  | 'application'
  | 'applicationAttachment'
  | 'syncEvent'
  | 'userAccount'
  | 'adminAccount'
  | 'apiClient'
  | 'policyAttachment';

export interface AuthenticationPayloadV2 extends AuthenticationPayloadBase {
  version: 2;
  resource: {
    type: AuthenticationPayloadResourcesV2;
    id: string;
  };
  scope: string;
}

export function isPayloadV1(payload: AuthenticationPayloadBase): payload is AuthenticationPayloadV1 {
  return !isNil(payload) && payload.version === undefined;
}

export function isPayloadV2(payload: AuthenticationPayloadBase): payload is AuthenticationPayloadV2 {
  return payload?.version === 2;
}
